import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillHelp = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17.83C11.31 17.83 10.75 17.27 10.75 16.58C10.75 15.89 11.31 15.33 12 15.33C12.69 15.33 13.25 15.89 13.25 16.58C13.25 17.27 12.69 17.83 12 17.83ZM13.33 12.76C13.03 12.89 12.83 13.19 12.83 13.53C12.83 13.99 12.46 14.36 12 14.36C11.54 14.36 11.17 13.99 11.17 13.53C11.17 12.54 11.76 11.64 12.67 11.24C13.51 10.87 13.9 9.89 13.53 9.05C13.16 8.21 12.18 7.82 11.34 8.19C10.73 8.45 10.34 9.05 10.34 9.71C10.34 10.17 9.97 10.54 9.51 10.54C9.05 10.54 8.68 10.17 8.68 9.71C8.68 7.87 10.18 6.38 12.02 6.38C13.86 6.38 15.35 7.88 15.35 9.72C15.35 11.04 14.56 12.24 13.35 12.77L13.33 12.76Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillHelp)
